// constants.ts
import { version } from './version';
export const DEFAULT_HEADERS = { 'X-Client-Info': `supabase-js/${version}` };
//# sourceMappingURL=constants.js.map